import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import generateAttributes from "../functions/generateAttributes";
import "../styles/App.scss";
import Menu from "./components/Menu/Menu.js";
import Home from "./pages/Home/Home.js";
import About from "./pages/About.js";
import Contact from "./pages/Contact.js";
import Insights from "./pages/Insights.js";
import Footer from "./components/Footer.js";
import ReactGA from "react-ga4";

function App(props) {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: location.pathname
        });
    }, [location]);

    // Prevents all transition on media queries change
    const [resizing, setResizing] = useState(false);
    useEffect(() => {
        window.addEventListener("resize", () => {
            setResizing(true);
            setTimeout(() => setResizing(false), 200);
        });
    }, []);
    const attr = generateAttributes("App", props, { resizing });

    return (
        <div {...attr()}>
            <Menu
                variations={location.pathname === "/" ? "overContent" : null}
            />
            <Routes>
                <Route path="/about" element={<About />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/" element={<Home />} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;
